// extracted by mini-css-extract-plugin
export default {"container":"BackupReminder_container__-3DRZ","header":"BackupReminder_header__h8Aor","content":"BackupReminder_content__g9cUU"};